import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function Section({
  children,
  className,
  id,
}: {
  children: ReactNode;
  className?: string;
  id?: string;
}) {
  return (
    <section id={id} className={cn("py-20 md:py-28", className)}>
      <div className="container-wide">{children}</div>
    </section>
  );
}

export function EyebrowHeading({
  eyebrow,
  title,
  lede,
  align = "left",
  as: Heading = "h2",
}: {
  eyebrow?: string;
  title: ReactNode;
  lede?: ReactNode;
  align?: "left" | "center";
  as?: "h1" | "h2";
}) {
  return (
    <div className={cn("max-w-4xl", align === "center" && "mx-auto text-center")}>
      {eyebrow && (
        <div className="mb-4 text-xs uppercase tracking-[0.18em] text-muted-foreground">
          {eyebrow}
        </div>
      )}
      <Heading className="text-balance text-4xl font-semibold leading-[1.05] md:text-6xl">
        {title}
      </Heading>
      {lede && (
        <p className="mt-6 text-pretty text-base text-muted-foreground md:text-lg">
          {lede}
        </p>
      )}
    </div>
  );
}
